import { twMerge } from "tailwind-merge"

import { ValueType } from "wealthmode-frontend"
import { Badge, Circle, Value } from "wealthmode-frontend/components"
import { HStack, Text, VStack } from "wealthmode-frontend/gluestack/ui"

export function GraphValues({
  title,
  titleClassName,
  value,
  valueType,
  valueClassName,
  subValue,
  subValueType,
  subValueClassName,
  textClassName,
  badge = null,
  alignment = "center",
  legend = null,
}: {
  title: string
  titleClassName?: string
  value: number | null
  valueType: ValueType
  valueClassName?: string
  subValue?: number | null
  subValueType?: ValueType
  subValueClassName?: string
  textClassName?: string
  badge?: React.ReactNode
  legend?: string | null
  alignment?: "left" | "right" | "center"
}) {
  return (
    <VStack
      key="benchmark"
      className={alignment == "left" ? "items-start" : alignment == "right" ? "items-end" : "items-center"}
    >
      <Text
        key="title"
        className={twMerge("text-sm text-foreground-secondary", titleClassName)}
      >
        {title}
      </Text>
      <HStack
        key="value"
        className="items-center"
      >
        {legend && alignment == "right" && <Legend color={legend} />}
        <Text
          key="value"
          className={twMerge("text-4xl", textClassName, valueClassName)}
        >
          <Value
            value={{ type: valueType, value: `${value}` }}
            className={twMerge(" text-[32px] sm:text-4xl font-bold", textClassName, valueClassName)}
          />
        </Text>
        {legend && alignment == "left" && <Legend color={legend} />}
      </HStack>

      {badge && <Badge variant={"positive"}>{badge}</Badge>}
    </VStack>
  )
}

function Legend({ color }: { color: string }) {
  return <Circle color={color} />
}
